import axios from 'axios';
import router from '../router/index';


const state = {
    token: localStorage.getItem("token") || "",
    user: {

    },
    status: "",
    errors: ""

};

const getters = {
    isLogedIn:  state   => !!state.token,
    authState:  state   =>  state.status,
    user:       state   =>  state.user,
    getErrors:   state   =>  state.errors
};

const actions = {

    //The login action
    async login({commit}, user){
        try { 
            commit("Auth_request");
            //await because you are calling an API, you need to wait for the response 
            console.log("API call to user loging initiated")
            let res = "";
            if(process.env.NODE_ENV === 'production') {
                res = await axios.post('/api/users/login', user);
            }else {
                res = await axios.post('http://localhost:5000/api/users/login', user);
            }
             
            if(res.data.success) {
                
                const token = res.data.token;
                const user = res.data.user;
                console.log("curent user is:");
                console.log(user);
                //store the token in local storage 
                localStorage.setItem("token", token);
                commit('save_profile', user);
                //set the axios default for API call
                axios.defaults.headers.common['Authorization'] = token;

                // commit Autirization sucess 
                commit('Auth_success', token, user);
            }
            return res;
        } catch (error) {
            commit('Authentication_error', error);
        }
    },
    saveUser({commit}, user) {
        commit('save_profile', user);
    },
     async logout({commit}) {
        //remove token from local storage
       await  localStorage.removeItem('token');
        //set the axios header to defauls
        delete axios.defaults.headers.common['Authorization']; 
        //commit a mutation to clear user information 
        commit('logout_user');
         router.push('/login');
        return;
    },

    async register({commit}, user){
        
        try {
            commit('start_registration');
            //console.log("Registration API CALL STARTED")
            let res = "";
            if(process.env.NODE_ENV === 'production') {
                 res = await axios.post('/api/users/register', user);
            }else {
                 res = await axios.post('http://localhost:5000/api/users/register', user);
            }
            
            //console.log("Registration API CALL RETURNED")
            if(res.data.success){
                commit('registration_success');
                }
                return res;
            } catch (error) {
                commit('Authentication_error', error);
        }
    }, 

    async getProfile({commit}){
        try {
            commit('load_profile')
            let res = await axios.get('/api/users/profile');
            commit('save_profile', res.data.user);
            return res;
        } catch (error) {
            commit('Authentication_error', error);
        }
    }

};

const mutations = {
    Authentication_error(state, error){
         console.log(error)   
        //state.errors = error.response.data.msg;
    },
    load_profile(){
        state.status ="Loading",
        state.errors= null
    },
    save_profile(state, user) {
        state.user  = user,
        //state.user.email = user.email
        state.errors= null,
        console.log("new user infor registered");
        console.log(user);
        console.log("state variable updated to:")
        console.log(state.user)
    },
    registration_success(state){
        state.status ="success",
        state.errors= null

    },
    start_registration(state){
        state.status ="Loading",
        state.errors= null
    },
    Auth_request(state) {
        state.state ="Loading",
        state.errors= null
    },

    Auth_success(state, token, user) {
        state.status    =   "Success",
        state.token     =   token,
        state.user      =   user,
        state.errors    =   ""
    }, 
    logout_user(state) {
        state.status ="",
        state.user="",
        state.token= "",
        state.errors=""
    }

};

export default {
    state, 
    getters, 
    actions,
    mutations
}